import { createRoute, useNavigate } from "@tanstack/react-router";
import { AppShell } from "@/components/ui/app-shell";
import { ScriptDetailPage, ScriptsShell } from "@/features/scripts";
import { rootRoute } from "./root";

export const scriptDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/scripts/$scriptId",
  component: function ScriptDetail() {
    const { scriptId } = scriptDetailRoute.useParams();
    const navigate = useNavigate();
    return (
      <AppShell>
        <ScriptsShell>
          <ScriptDetailPage scriptId={scriptId} onBack={() => navigate({ to: "/" })} />
        </ScriptsShell>
      </AppShell>
    );
  },
});
